'use strict';

var client = require('@apollo/client');
var experimentalNextjsAppSupport = require('@apollo/experimental-nextjs-app-support');
var configureCache = require('../utils/configureCache.js');
var getClientConstants = require('../utils/getClientConstants.js');

function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const { PUBLIC_GRAPHQL_ENDPOINT } = getClientConstants();
/**
 * Creates a new Apollo Client instance.
 * @param initialState The initial state of the Apollo cache.
 * @param uri The URI of the GraphQL API. Defaults to "/api/graphql".
 */ function makeClient(_param) {
    var { initialState = {}, uri = PUBLIC_GRAPHQL_ENDPOINT } = _param, cacheConfig = _object_without_properties_loose(_param, [
        "initialState",
        "uri"
    ]);
    initialState = initialState != null ? initialState : typeof window !== 'undefined' && '__APOLLO_STATE__' in window ? window.__APOLLO_STATE__ : {};
    const httpLink = new client.HttpLink({
        uri
    });
    return new experimentalNextjsAppSupport.ApolloClient({
        cache: new experimentalNextjsAppSupport.InMemoryCache(configureCache(cacheConfig)).restore(initialState),
        link: typeof window === 'undefined' ? client.ApolloLink.from([
            new experimentalNextjsAppSupport.SSRMultipartLink({
                stripDefer: true
            }),
            httpLink
        ]) : httpLink
    });
}

module.exports = makeClient;
